import { campaignService } from 'api/services/campaign'
import { CampaignType } from 'api/types/campaign'
import { Wrapper } from 'components'
import { format } from 'date-fns'
import { Button, Card, toast } from 'keep-react'
import { Download } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { deltaToHtmlQuill } from 'utils/quillToHtml'

export const Campaigns = () => {
  const [data, setData] = useState<CampaignType[]>([])
  const [columns, setColumns] = useState<number>(2)
  const navigate = useNavigate()

  const getCampaigns = async () => {
    try {
      const response =
        (await campaignService.getCampaignList()) as CampaignType[]
      setData(response)
    } catch (error) {
      toast.error('Erro ao carregar as campanhas.')
      console.error('Error fetching campaigns:', error)
    }
  }

  useEffect(() => {
    getCampaigns()
  }, [])

  useEffect(() => {
    if (data.length <= 3) {
      setColumns(2)
      return
    }

    if (data.length === 3) {
      setColumns(3)
      return
    }

    if (data.length === 4) {
      setColumns(4)
      return
    }

    setColumns(4)
  }, [data])

  const pdf =
    data.length > 0 ? data[0].files.find(file => file.label !== 'Imagem') : null

  return (
    <div className="w-full flex-1 py-12 overflow-auto">
      <Wrapper>
        <h2 className="uppercase text-sm font-medium text-metal-900">
          Campanhas em curso
        </h2>
        <h1 className="pb-10 text-xxxl font-medium text-primary-600">
          Campanhas
        </h1>
        <div
          className={`grid grid-cols-${columns} items-start justify-start flex-wrap gap-4`}
        >
          {data &&
            data.length > 0 &&
            data.map((campaign: CampaignType, index: number) => {
              const html = campaign.content
                ? deltaToHtmlQuill(campaign.content)
                : ''
              return (
                <Card
                  key={`campaign${index}`}
                  className="block w-full rounded-2xl max-w-none"
                >
                  <img
                    className="block w-full h-[235px] object-cover"
                    src={
                      (campaign.files &&
                        campaign.files.find(file => file.label === 'Imagem')
                          ?.uri) ??
                      ''
                    }
                    alt={campaign.title}
                  />
                  <div className="flex flex-col px-6 py-5 space-y-4">
                    <h3 className="text-body-1 uppercase text-metal-900 tracking-wider">
                      {campaign.title}
                    </h3>
                    <h4 className="text-primary-600 text-body-3 uppercase tracking-tight">
                      {campaign.description}
                    </h4>
                    <div
                      className="[&_h2]:text-xxl [&_h3]:text-xl [&_h4]:text-lg [&_h2]:py-4 [&_h3]:py-3 [&_h4]:py-2 [&_p]:text-body-4 [&_p]:pb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:pb-4 [&_ul]:text-body-4 [&_ol]:list-disc [&_ol]:pl-6 [&_ol]:pb-4 [&_ol]:text-body-4 [&_a]:text-primary-600 [&_a]:underline"
                      dangerouslySetInnerHTML={{ __html: html }}
                    ></div>
                    <div className="text-metal-900 text-body-4 tracking-tight">
                      {format(new Date(campaign.expirationDate), 'dd-MM-yyyy')}
                    </div>
                    {campaign.link && campaign.label && (
                      <Button
                        color="primary"
                        variant="default"
                        onClick={() => navigate(campaign.link)}
                      >
                        {campaign.label}
                      </Button>
                    )}
                    {pdf?.uri && pdf?.label && (
                      <a
                        href={pdf.uri ?? ''}
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center gap-2 text-primary-600 text-body-4 pb-2"
                      >
                        {<Download size={14} weight="fill" />}
                        {(campaign.files &&
                          campaign.files.find(file => file.label !== 'Imagem')
                            ?.label) ??
                          ''}
                      </a>
                    )}
                  </div>
                </Card>
              )
            })}
        </div>
      </Wrapper>
    </div>
  )
}
